import React, { Component } from "react";
import { Row, Col } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TableRender from "../RenderTable/TableRender";
import GrantSearch from "../RenderTable/GrantSearch";
import { NoData } from "../../../../../../CommonComponents/commonStyles";
import { milliToDate } from "../../../../../../utils/commonUtil";
import MobileSearch from "../ContentComponent/MobileSearch";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import  PropTypes from 'prop-types';
import { updateSingleGrants } from "../../actions"
import { TabContentDerivedStates } from "../../selectors"

 class TabContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterUsed: false,
      filteredData: [],
      search: "",
      cleared: false,
      grantDropDownOptions: {
        flag: false,
        options: {
          status: []
        }
      },
      filters: [],
      type: '',
      fromFilter: false,
      filterLoader: false
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidUpdate(prevProp){
  
    const { data, avail, singleData, recurringData,  tab, updateSingleGrants, lazyLoaded, lazyLodedRec} = this.props;
    const { allSingleGrants, singleGrants } = singleData;
    const { fromFilter, filters, type } = this.state;
   
    if( tab === "1" && prevProp.data !== data && prevProp.lazyLoaded !== lazyLoaded && prevProp.singleData !== singleData) {
      this.handleSearch(filters, type)
    }

    if( tab === "2" && prevProp.data !== data && prevProp.lazyLodedRec !== lazyLodedRec && prevProp.recurringData !== recurringData) {
      this.handleSearch(filters, type)
    }

    // Update All Single grants if not already updated
    if(avail && tab === "1" && allSingleGrants && allSingleGrants !== singleGrants && fromFilter){
     
      updateSingleGrants(singleData.singleGrants);
     
    }

    // Filter data from Updated Single grants
    if(tab === "1" && allSingleGrants && allSingleGrants.length === singleGrants.length && fromFilter) {
      this.setState({ fromFilter: false }, ()=> this.handleSearch(filters, type))
    }
  }

  handleSearch = (filters, type = '') => {
    const { search, dates, status, frequency } = filters;
    const { data, highlightThis, setPrinter, avail, tab, getDataSource } = this.props;
    
    if (!search && !dates && !status && !frequency) {
      this.setState({
        isFilterUsed: false,
        filteredData: [...data]
      });
    }

    this.setState({
      filters: filters,
    });

    // if(avail && tab === "1" && this.state.isFilterUsed){
    //   return this.setState({ filters, type, fromFilter: true, filterLoader: true });
    // }
    
    //Before Filter Manipulations
    let filteredData = [...data];
    let filtered = filteredData.filter((each, index) => {
    let isfrequency, isSearch, isStatus, isDate;

      //frequency
      if (frequency && frequency.length) {
        isfrequency = frequency.includes(each.frequency);
      } else isfrequency = true;

      //search
      if (search) {
        if (each.charityName) {
          isSearch = each.charityName
            .toLowerCase()
            .includes(search.toLowerCase());
        } else {
          isSearch = each.granteeOrg.legalName
            .toLowerCase()
            .includes(search.toLowerCase());
        }
      } else isSearch = true;

      //status
      if (status && status.length) {
        if (each.status.description) {
          isStatus = status.includes(each.status.description);
        } else if (each.status) {
          isStatus = status.includes(each.status);
        }
      } else isStatus = true;

      //dates
      if (dates) {
        const date1 = moment(dates[0], "MM/DD/YYYY");
        const date2 = moment(dates[1], "MM/DD/YYYY");
        if (each.gaStartDate) {
          isDate = moment(each.gaStartDate).isBetween(date1, date2, null, '[]');
        } else if (each.enteredDate) {
          isDate = moment(each.enteredDate).isBetween(date1, date2, null, '[]');
        }
      } else isDate = true;

      return isSearch && isfrequency && isStatus && isDate;
    });
    
    if(type === 'timeframe'){
      let grantDropDownOptions = JSON.parse(JSON.stringify(this.state.grantDropDownOptions));
      if(this.props.card === "GrantCard"){
        //Update Grants tab w.r.t timeframe
        let tempStatus = [];
        filtered.forEach(each => {
          if (tempStatus.indexOf(each.status) < 0) {
            tempStatus.push(each.status);
          }
        });
       // grantDropDownOptions.flag = true;
       // grantDropDownOptions.options.status = tempStatus;
      }else if(this.props.card === "RecurringCard") {
        // Updating View and Schedules tabs w.r.t timeframe
        let reStatus = [];
        let reFrequency = [];
        filtered.forEach(each => {
          if (reStatus.indexOf(each.status) < 0) {
            reStatus.push(each.status);
          }
          if (reFrequency.indexOf(each.frequency) < 0) {
            reFrequency.push(each.frequency);
          }
        });
        // grantDropDownOptions.flag = true;
        // grantDropDownOptions.options.status = reStatus;
        grantDropDownOptions.options.frequency = reFrequency;
      }else{
        // Updating Grant Agreement tabs w.r.t timeframe
        let gaStatus = [];
        filtered.forEach(each => {
          if (gaStatus.indexOf(each.status.description) < 0) {
            gaStatus.push(each.status.description);
          }
        });
        grantDropDownOptions.flag = true;
        grantDropDownOptions.options.status = gaStatus;
      }
      this.setState({grantDropDownOptions});
    }

    //Set final Data to State
    this.setState({
      filteredData: filtered,
      isFilterUsed: true,
      filterLoader: false

    });
    setPrinter(filtered);
    //Handle No Data Feedback UI
    if (filteredData.length === 0) {
      this.setState({ search });
    }

    //For HighLighter Search Functionality
    highlightThis(search);
    getDataSource(filtered);
  };


  render() { 
    const { data, column, text, card, options, tab, tabKey, className, sgShowLoader, handleChange, getDataSource } = this.props;
    const { search, filteredData, isFilterUsed, grantDropDownOptions, filterLoader } = this.state; 
    return (
      <>
        {options && (
          <Row>
            <Col lg={24} md={0} xs={0} sm={0}>
              <GrantSearch
                handleSearch={this.handleSearch}
                options={grantDropDownOptions.flag ? grantDropDownOptions.options : options}
                tab={tab}
                tabKey={tabKey}
              />
            </Col>
            <Col id="mobileView" lg={0} sm={24} xs={24} md={24}>
              {options && options.status && (
                <MobileSearch handleSearch={this.handleSearch} menu={grantDropDownOptions.flag ? grantDropDownOptions.options : options} />
              )}
            </Col>
          </Row>
        )}
        {
          (sgShowLoader || filterLoader)  && <Preloader />
        }
        { !sgShowLoader && !filterLoader && !isFilterUsed && data.length > 0 && (
          <TableRender
            className={className}
            data={data}
            column={column}
            card={card}
            tab={tab}
            search={search}
            text={text}
            handleChange={ handleChange ? (pagination, filters, sorter, extra)=> handleChange(sorter, extra) : undefined}
          />
        )}
        { !filterLoader && isFilterUsed && filteredData && (
          <TableRender
            className={className}
            data={filteredData}
            column={column}
            card={card}
            tab={tab}
            search={search}
            text={text}
            handleChange={ handleChange ? (pagination, filters, sorter, extra)=> handleChange(sorter, extra) : undefined}
            getDataSource={(currentData)=> getDataSource(currentData)}
          />
        )}     
        { !filterLoader && !filteredData.length && search && (
          <TableRender
            className={className}
            data={filteredData}
            column={column}
            card={card}
            tab={tab}
            search={search}
            text={text}
            handleChange={ tab === "1"  && handleChange ? (pagination, filters, sorter, extra)=> handleChange(sorter, extra) : undefined}
          />
        )}
      </>
    );
  }
}

TabContent.propTypes = {
  setPrinter: PropTypes.func,
  className: PropTypes.string,
  data: PropTypes.array,
  card: PropTypes.string,
  tab: PropTypes.string,
  singleData: PropTypes.object,
  avail: PropTypes.bool,
  sgShowLoader: PropTypes.bool
}

const mapStateToProps = state => ({
  ...TabContentDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  updateSingleGrants: (data) => dispatch(updateSingleGrants(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TabContent)
)

